"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var navigationStyles = styles_1.makeStyles(function (_a) {
    var _b, _c;
    var breakpoints = _a.breakpoints, typography = _a.typography, palette = _a.palette;
    return ({
        root: {
            backgroundColor: palette.primary.main,
            position: 'sticky',
            top: 0,
            zIndex: 3,
        },
        wrapper: {
            margin: 'auto',
            maxWidth: 1440,
        },
        backContainer: (_b = {
                position: 'relative'
            },
            _b[breakpoints.down(breakpoints.values.md)] = {
                backgroundColor: palette.primary.main,
                textAlign: 'center',
            },
            _b),
        backButton: (_c = {
                border: '0 none',
                color: palette.primary.contrastText,
                fontSize: typography.fontSM,
                position: 'absolute',
                top: '15px',
                left: '10px',
                cursor: 'pointer'
            },
            _c[breakpoints.down(breakpoints.values.md)] = {
                position: 'relative',
                top: 0,
                left: 0,
            },
            _c),
        backLabel: {
            color: 'inherit',
        },
        backIcon: {
            color: 'inherit',
            fontSize: 'inherit',
        },
        headerContainer: {
            padding: '15px 0',
            border: "1px solid " + palette.background.alternate,
        },
        headerTitle: {
            textAlign: 'center',
            fontSize: typography.fontXL,
            lineHeight: 1.2,
            color: palette.primary.contrastText,
        },
    });
}, { name: 'Checkout4_Navigation' });
exports.default = navigationStyles;
